import React, { useEffect, useState } from "react";
import { useRef } from "react";
import axiosInstance from "../server/axios";
import { Button } from "@mui/material";
/*
import UploadExcel from "./cartable/uploadexcel";
import Uploadcsv from "./cartable/uploadcsv";
*/
const usergrade = localStorage.getItem("happycallgrade");
const Home = () => {
/*
  //dragging
  const dragItem = useRef(null); // Specify the type for dragItem
  const dragOverItem = useRef(null); // Specify the type for dragOverItem
  const [itemCount, setItemCount] = useState([5,5]);
  const [list, setList] = useState([
    `item1`,
    `item2`,
    `item3`,
    `item4`,
    `item5`,
    `item6`,
    `item7`,
    `item8`,
    `item9`,
    `item0`,
  ]);
  const dragStart = (e,position) => {
    dragItem.current = position;
  };
  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };
  const drop = (e) => {
    const copyListItems = [...list];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
//    sortFilter(copyListItems);
    setList(copyListItems);
  };
*/
const formatDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

const [orderDay, setOrderDay] = useState(formatDate(new Date()));
const moveDay = (days) => {
  const date = new Date(orderDay);
  date.setDate(date.getDate() + days);
  setOrderDay(formatDate(date));
};
//const beforeOrderDay = () => moveDay(-1);
//const afterOrderDay = () => moveDay(1);
const clickOrderday = (e) => setOrderDay(e.target.value);

const [day_total, setDay_total] = useState(0);
const [thismonth_total, setThismonth_total] = useState(0);
const [thisyear_total, setThisyear_total] = useState(0);
const [comparedMonth, setCompareMonth_total] = useState(0);
const [comparedYear, setCompareYear] = useState(0);
const commaNumber = (number) => {return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
const [visitLog, setVisitLog] = useState(0);
const [delivery, setDelivery] = useState([]);
const [otherToday, setOtherToday] = useState([]);
const [schedule, setSchedule] = useState([]);
const [dateList, setDateList] = useState([]);
const [username, setUsername] = useState('');
useEffect(()=>{
  getFulldata();
  async function getFulldata(){
    const serverData = await axiosInstance.get(`/company/home?day=${orderDay}`)
    //console.log(serverData.data);
    const day_total = serverData.data[0][0].day_total;
    const thismonth_total = serverData.data[0][0].thismonth_total;
    const thisyear_total = serverData.data[0][0].thisyear_total;
    const lastmonth_total = serverData.data[0][0].lastmonth_total;
    const lastyear_total = serverData.data[0][0].lastyear_total;
    const comparedMonth = Math.round(((thismonth_total-lastmonth_total)/thisyear_total)*100);
    const comparedYear =  Math.round(((thisyear_total-lastyear_total)/thisyear_total)*100);
    setDay_total(day_total)
    setThismonth_total(thismonth_total)
    setThisyear_total(thisyear_total)
    setCompareMonth_total(comparedMonth)
    setCompareYear(comparedYear)
    setVisitLog(serverData.data[1][0].count)
    
    const username = serverData.data[4];
    setUsername(username);

    const delivery = [];
    for(let i = 0; i < serverData.data[2].length; i++){
      const deliveryObj = {
        company : serverData.data[2][i].order_company,
        material : serverData.data[2][i].material,
        material_weight : serverData.data[2][i].material_weight,
        note : serverData.data[2][i].note
      }
      delivery.push(deliveryObj);
    }
    setDelivery(delivery);

    const otherTodayWork = [];
    for(let i = 0; i < serverData.data[3].length; i++){
      if(serverData.data[3][i].visitor === username && 
         serverData.data[3][i].due_date === orderDay ){
          if(serverData.data[3][i].company.indexOf('입고-') !== -1 ||
            serverData.data[3][i].weight === 0){
              otherTodayWork.push(serverData.data[3][i]);
          }
      }
    }
    setOtherToday(otherTodayWork)

    const dumyList = [];
    for(let i = 0; i < serverData.data[3].length; i++){
      dumyList.push(serverData.data[3][i].due_date);
    }
    const dateList = [...new Set(dumyList)];
    dateList.sort();

    const visitorArr = [];
    let listarr = Array.from({length:dateList.length+1},(val)=>[]);
    let visitor = 'initial';
    for(let i = 0; i < serverData.data[3].length; i++){
      const serverVisitor = serverData.data[3][i].visitor;
      if(visitor !== serverVisitor){
        if(i !== 0){visitorArr.push(listarr);}
        listarr = Array.from({length:dateList.length+1},(val)=>[]);
        visitor = serverVisitor;
        listarr[0].push(serverVisitor);
      }
      if(visitor === serverVisitor){
        const dueDate = serverData.data[3][i].due_date;
        const arrIndex = dateList.indexOf(dueDate)+1;
        listarr[arrIndex].push([
          serverData.data[3][i].company,
          serverData.data[3][i].weight
        ]);
      }
      if(i === serverData.data[3].length -1){visitorArr.push(listarr);}
    }

    const days = ['일','월','화','수','목','금','토'];
    const addDateList = [];
    for(let i = 0; i < dateList.length; i++){
      const date = new Date(dateList[i]);
      const weekDay = days[date.getDay()];
      addDateList.push({date:dateList[i],weekDay:weekDay})
    }
    setDateList(addDateList);
    setSchedule(visitorArr);

//const [schedule, setSchedule] = useState([]);
//const [dateList, setDateList] = useState([]);

    /*
    company: " 케이보은제약"
    company_code: "01826"
    due_date: "2026-06-16"
    material: "Tetrasodium Pyrophosphate (피로인산나트륨)"
    note: ""
    result: "X"
    sorting: null
    visitor: "김상민"
    weight: 50
    */

    //console.log(serverData.data);
  }
},[orderDay])
  return (
    <>
    {
    usergrade === 'check' || usergrade === null || usergrade === undefined || usergrade === ''?
    <div>GUEST GRADE</div>
    :
    <div>
      <div className="orderboard_orderday" style={{display:'flex',justifyContent:'center'}}>
        <Button variant="outlined" onClick={() => moveDay(-1)}>◀</Button>
        <input type="date" value={orderDay} onChange={clickOrderday}/>
        <Button variant="outlined" onClick={() => moveDay(1)}>▶</Button>
      </div>

        <table border={1}>
          <thead>
          <tr>
            <th colSpan={4}>{orderDay} </th>
          </tr>
          <tr>
            <th>일매출</th>
            <th>월매출[작년대비:{comparedMonth}%]</th>
            <th>연매출[작년대비:{comparedYear}%]</th>
            <th>방문록작성</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{commaNumber(day_total)}</td>
            <td>{commaNumber(thismonth_total)}</td>
            <td>{commaNumber(thisyear_total)}</td>
            <td>{visitLog} 건</td>
          </tr>
          </tbody>
        </table>

      <div style={{border:'1px solid red'}}>
        {delivery.length === 0 ?
          <div><b>{orderDay} {username} 납품일정은 없습니다</b></div>
          :
          <></>
        }
        <table border={1}>
        {delivery.map((value,i)=>
          delivery.length > 0 ?
            i === 0 ?
            <>
            <tr>
              <th colspan={4}>{username} 납품 일정</th>
            </tr>
            <tr>
              <th>납품처</th>
              <th>원료명</th>
              <th>kg</th>
              <th>비고</th>
            </tr>
            <tr>
              <td align="left">{value.company}</td>
              <td align="left">{value.material}</td>
              <td align="right">{value.material_weight}</td>
              <td align="left" style={{color:"red"}}>{value.note}</td>
            </tr>
            </>
            :
          <tr>
            <td align="left">{value.company}</td>
            <td align="left">{value.material}</td>
            <td align="right">{value.material_weight}</td>
            <td align="left" style={{color:"red"}}>{value.note}</td>
          </tr>
          :
          <></>
        )}
        </table>
        <table border={1}>
          {otherToday.map((value,i)=>
          otherToday.length > 0 ?
          i === 0 ?
          <>
            <tr>
              <th colspan={4}>{username} 납품 외 일정</th>
            </tr>
            <tr>
              <th>일정</th>
              <th>원료명</th>
              <th>kg</th>
              <th>비고</th>
            </tr>
            <tr>
              {value.company === value.material ?
              <td align="left" colspan={3}>{value.company}</td>
              :
              <>
              <td align="left">{value.company}</td>
              <td align="left">{value.material}</td>
              <td align="right">{value.weight}</td>
              </>
              }
              <td align="left" style={{color:"red"}}>{value.note}</td>
            </tr>
          </>
          :
          <tr>
              {value.company === value.material ?
              <td align="left" colspan={3}>{value.company}</td>
              :
              <>
              <td align="left">{value.company}</td>
              <td align="left">{value.material}</td>
              <td align="right">{value.weight}</td>
              </>
              }
            <td align="left" style={{color:"red"}}>{value.note}</td>
          </tr>
          :
          <></>
          )}
        </table>
      </div>

      <div>
        <div style={{width:'100%',maxWidth:'1000px'}}>주간 일정 </div>
        <table border={1} style={{
          width: '100%',
          maxWidth:'1000px',
          tableLayout: 'fixed',
          fontSize:'0.8rem',borderCollapse:"collapse",border:'1px solid black'
          }}>
          <tr style={{top:'0px',position: 'sticky'}}>
            <th style={{width:'48px',backgroundColor:'white'}}>분류</th>
            {dateList.map((data)=>
              <th>
                <div style={{
                  borderBottom:'1px solid black',
                  backgroundColor:data.date === orderDay ? 'powderblue' :'white'
                }}>
                  {data.date} {data.weekDay}
                </div>
              </th>
            )}
          </tr>
            {schedule.map((valarr,j)=>
            <tr>
              {valarr.map((visitlist,i)=>
              i === 0 ?
              <td>{visitlist}</td>
              :
              <td 
              style={{marginLeft:'3px',marginRight:'3px',backgroundColor:dateList[i-1].date === orderDay ? 'powderblue':'white'}}
              >
              {visitlist.map((data)=>
              <div style={{display:'flex',justifyContent: 'space-between'}}>
                <div style={{textAlign:'left',whiteSpace: "nowrap", overflow: "hidden"}}>{data[0]}</div>
                {data[1] !== 0 ?
                  <div>{data[1]}</div>
                  :
                  <></>
                }
              </div>
              )}</td>
              )}
            </tr>
            )}
        </table>

      </div>
{/*
      <div>
        <div><b>{orderDay} 일정</b></div>
        <div style={{display:"flex",flexDirection:"row",flexWrap: "wrap",alignItems:"flex-start",fontSize:"13px"}}>
        {schedule.map((data)=>
          <table border={1} style={{marginRight:"15px",marginBottom:"20px"}}>
            <tr><th colSpan={3}>{data[0]}, [{data[1].length}]건</th></tr>
            {data[1].map((value)=>
            value.company === value.material ?
            <tr>
              <td align="left" colSpan={3}>{value.company}</td>
            </tr>
            :
            <tr>
              <td align="left">{value.company}</td>
              <td align="left">{value.material}</td>
              <td align="right">{value.weight} kg</td>
           </tr>
            )}
          </table>
        )}
        </div>
      </div>

*/}


    </div>
    }

      {/*
      <div style={{width:'100px',height:'100px',backgroundColor:'powderblue'}}>
        <div>group</div>
      </div>
      <div style={{width:'100px',height:'100px',backgroundColor:'yellow'}}>
        <div>group</div>
      </div>
      {
        list.map((item, index) => (
          <div
            key={index}
            draggable
            onDragStart={(e) => dragStart(e, index)}
            onDragEnter={(e) => dragEnter(e, index)}
            onDragEnd={drop}
            onDragOver={(e) => e.preventDefault()}
          >
            {item}
          </div>
        ))
      }
        <div>{UploadExcel('user')}</div>
        <div>{Uploadcsv('user')}</div>
      */}
    </>
  );
}
export default Home;